var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.466,
    height: 82.762,
    viewBox: "0 0 127.466 82.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M232.5,155.713c-19.789-21.621-40.066-32.513-60.268-32.513s-40.478,10.892-60.268,32.513a13.08,13.08,0,0,0,0,17.736c19.789,21.621,40.066,32.513,60.268,32.513s40.478-10.937,60.268-32.513a13.081,13.081,0,0,0,0-17.736Zm-6.533,11.823c-18.045,19.626-36.118,29.558-53.734,29.558s-35.691-9.932-53.737-29.558a4.345,4.345,0,0,1,0-5.822c18.046-19.715,36.118-29.647,53.737-29.647s35.691,9.932,53.737,29.557a4.346,4.346,0,0,1,0,5.911Zm-53.734-23.5a20.558,20.558,0,1,0,14.521,6.021,20.543,20.543,0,0,0-14.521-6.021Zm0,32.218a11.675,11.675,0,1,1,8.255-3.419A11.674,11.674,0,0,1,172.236,176.256Z",
    transform: "translate(-108.501 -123.2)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.9a416847ac3e06a9ff91911f908321b5.svg";
export { ForwardRef as ReactComponent };